import { Injectable } from '@angular/core';
import { SimuladorGoApi } from '@gestor-web/@core/api/go';
import { map } from 'rxjs/operators';

@Injectable()
export class ConsultasMedicasEletivasService {
  constructor(private simuladorGoApi: SimuladorGoApi) {}

  getData(
    regans: string,
    competenciaInicial: string,
    competenciaFinal: string,
    ano_realizacao: number,
    id_faixa_etaria: number,
    ib_critica_pendente: boolean,
  ) {
    return this.simuladorGoApi
      .fetchConsultasMedicasEletivas({
        regans,
        competencia: competenciaInicial,
        competencia_final: competenciaFinal,
        ano_realizacao,
        id_faixa_etaria,
        ib_critica_pendente: ib_critica_pendente ? 1 : 0,
      })
      .pipe(map(data => data.items));
  }
}
